import { render, staticRenderFns } from "./swiperSmall2.vue?vue&type=template&id=29dd58b3&scoped=true&"
import script from "./swiperSmall2.vue?vue&type=script&lang=js&"
export * from "./swiperSmall2.vue?vue&type=script&lang=js&"
import style0 from "./swiperSmall2.vue?vue&type=style&index=0&id=29dd58b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd58b3",
  null
  
)

export default component.exports